module.exports = __webpack_public_path__ + "inistate-logo.png?3699fbcfe59599d7a99df1b4f624ac33";